export const holiday = [
    {
        id: "H752762",
        holidayTitle: "New Year",
        date: "01 Jan 2025",
        description: "First day of the new year",
        status: "Active"
      },
      {
        id: "H752761",
        holidayTitle: "Chinese New Year",
        date: "29 & 30 Jan 2025",
        description: "Celebrating the Chinese New Year",
        status: "Active"
      },
      {
        id: "H752760",
        holidayTitle: "Presidents' Day",
        date: "11 Feb 2025",
        description: "Thaipusam",
        status: "Active"
      },
      {
        id: "H752759",
        holidayTitle: "Good Friday",
        date: "29 Mar 2025",
        description: "Holiday before Easter",
        status: "Active"
      },
      {
        id: "H752758",
        holidayTitle: "Hari Raya Aidilfitri",
        date: "01, 02 Apr 2025",
        description: "Hari Raya Aidilfitri Holidays",
        status: "Active"
      },
      {
        id: "H752757",
        holidayTitle: "Labour Day",
        date: "01 May 2025",
        description: "Labour Day",
        status: "Active"
      },
      {
        id: "H752756",
        holidayTitle: "Wesak Day",
        date: "12 May 2025",
        description: "Wesak Day Holiday",
        status: "Active"
      },
      {
        id: "H752755",
        holidayTitle: "Merdeka Day",
        date: "01 Sep 2025",
        description: "Merdeka Day Holiday",
        status: "Active"
      },
      {
        id: "H752754",
        holidayTitle: "Malaysia Day",
        date: "16 Sep 2025",
        description: "Malaysia Day",
        status: "Active"
      },
      {
        id: "H752754",
        holidayTitle: "Deepavali",
        date: "20 Oct 2025",
        description: "Deepavali Day",
        status: "Active"
      },
      {
        id: "H752753",
        holidayTitle: "Christmas Day",
        date: "25 Dec 2025",
        description: "Celebration of Christmas",
        status: "Active"
      }
]
